import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Button from '../Button/CustomButton';
import GridItem from '../Grid/GridItem';
import GridContainer from '../Grid/GridContainer';
import SuccessDialog from '../Dialog/SuccessDialog';
import Typography from '../Typography/CustomTypography';
import * as Action from '../../actions/EventManagement';

import styles from '../../assets/jss/components/registerLinksStyle';

const useStyles = makeStyles(styles);

const RegisterLinks = (props) => {
    const { eventInfo, fetchInfoEvent, locale } = props;
    const history = useHistory();
    const intl = useIntl();
    const classes = useStyles(props);
    const { shortName } = useParams();
    const [isOpenDialog, setIsOpenDialog] = useState(false);

    useEffect(() => {
        fetchInfoEvent({ shortName, language: locale });
    }, [shortName, locale]);

    const handleLinkToRegisterOrganizer = () => {
        const utcDateNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
        utcDateNow.setHours(0, 0, 0, 0);
        const timeRunningStart = new Date(eventInfo.sdate);
        const time7Day = new Date(timeRunningStart.setDate(timeRunningStart.getDate() - 7));
        time7Day.setHours(0, 0, 0, 0);
        if (time7Day < utcDateNow) {
            setIsOpenDialog(true);
        } else {
            history.push(`/${eventInfo.short_name}/register-exhibitor`);
        }
    };

    return (
        <GridContainer className={classes.wrapper}>
            <GridItem xs={12} sm={6} className={classes.leftButtonWrapper}>
                <Button
                    style={{ margin: '15px' }}
                    color="info"
                    round
                    gradient
                    onClick={() => history.push(`/${shortName}/register-visitor`)}
                    className={classes.buttonBig}
                    buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                    buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.viewer}
                >
                    <b>{intl.formatMessage({ id: 'home.admissionApplication' })}</b>
                </Button>
            </GridItem>
            <GridItem xs={12} sm={6}>
                <Button
                    style={{ margin: '15px' }}
                    color="warning"
                    round
                    onClick={handleLinkToRegisterOrganizer}
                    gradient
                    className={classes.buttonBig}
                    buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                    buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.organizer}
                >
                    <b>{intl.formatMessage({ id: 'home.exhibitApplication' })}</b>
                </Button>
            </GridItem>
            <SuccessDialog
                title=""
                open={isOpenDialog}
                contents={(
                    <Typography customColor={eventInfo?.settings_colors_viewer?.contents_text_color}>
                        {intl.formatMessage({ id: 'home.textRegisterFail' })}
                        <br />
                        {intl.formatMessage({ id: 'home.textRegisterFailNote' })}
                    </Typography>
                )}
                handleClose={() => setIsOpenDialog(false)}
                customColor={eventInfo?.settings_colors_viewer}
            />
        </GridContainer>

    );
};

RegisterLinks.defaultProps = {
    eventInfo: {},
    locale: '',
};

RegisterLinks.propTypes = {
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    fetchInfoEvent: PropTypes.func.isRequired,
    locale: PropTypes.string,
};
const mapStateToProps = (state) => ({
    eventInfo: state.eventManagement.infoEvent.data,
    locale: state.locale.lang.current,
});
const mapDispatchToProps = (dispatch) => ({
    fetchInfoEvent: (param) => dispatch(Action.GetInfoEventRequested(param)),
});
export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(RegisterLinks);
